<template>
    <div class="mb-3">
        <div class="card">
            <div class="card-header bg-primary text-white">
                <page-title :title="($t('organizationalModel.edit'))"></page-title>
            </div>

            <div class="card-body">
                <div class="form-row">
                    <div class="form-group col-md-4 col-sm-12">
                        <label class="col-form-label font-weight-bold required" :for="'organizationalModelName' + _uid">{{ $t('organizationalModel.gridHeaders.name') }}</label>
                        <input v-if="editing" type="text" class="form-control"
                               v-model="model.name"
                               :name="'organizationalModelName' + _uid"
                               :id="'organizationalModelName' + _uid"
                               v-validate="'required'">
                        <input v-else type="text" readonly class="form-control-plaintext"
                               :name="'organizationalModelName' + _uid"
                               :id="'organizationalModelName' + _uid"
                               :value="model.name">
                        <span class="text-danger"
                              v-if="errors.has('organizationalModelName' + _uid)">{{ errors.first('organizationalModelName' + _uid) }}</span>
                    </div>
                    <div class="form-group col-md-4 col-sm-12">
                        <label class="col-form-label font-weight-bold" for="organizationalModelNameEn">{{ $t('organizationalModel.gridHeaders.nameEn') }}</label>
                        <input v-if="editing" v-model="model.nameEn" type="text" class="form-control" id="organizationalModelNameEn">
                        <input v-else type="text" readonly class="form-control-plaintext" id="organizationalModelNameEn" :value="model.nameEn">
                    </div>
                    <div class="form-group col-md-4 col-sm-12 pt-4">
                        <vs-checkbox v-model="model.deactivated"
                                     :disabled="!editing"
                                     :name="'organizationalModelDeactivated' + _uid"
                                     :id="'organizationalModelDeactivated' + _uid">
                            {{ $t('organizationalModel.gridHeaders.deactivated') }}
                        </vs-checkbox>
                    </div>

                    <div class="form-group col-md-6 col-sm-12">
                        <multi-select :loadByParentSort="true"
                                      :parentSort="eventFormSort"
                                      :fieldName="$t('organizationalModel.eventForm')"
                                      v-model="model.eventFormIds"
                                      :isCity="false"
                                      :readonly="!editing"
                                      aria-describedby="eventFormHelpBlock">
                        </multi-select>
                        <small id="eventFormHelpBlock" class="form-text text-muted">
                            {{ $t('organizationalModel.eventForm') }}
                        </small>
                    </div>

                    <!--<div class="form-group col-md-6 col-sm-12">
                        <multi-select :loadByParentSort="true"
                                      :parentSort="eventActivitySort"
                                      :fieldName="$t('organizationalModel.eventActivity')"
                                      v-model="model.eventActivityIds"
                                      :isCity="false"
                                      :readonly="!editing"
                                      aria-describedby="eventActivityHelpBlock">
                        </multi-select>
                        <small id="eventActivityHelpBlock" class="form-text text-muted">
                            {{ $t('organizationalModel.eventActivity') }}
                        </small>
                    </div>-->

                    <div class="form-group col-md-6 col-sm-12">
                        <dynamic-multi-select :api-url="`/api/dropdown/GetActivities`"
                                              :readonly="!editing"
                                              v-model="model.eventActivityIds"
                                              :fieldName="$t('organizationalModel.eventActivity')"></dynamic-multi-select>
                        <small id="eventActivityHelpBlock" class="form-text text-muted">
                            {{ $t('organizationalModel.eventActivity') }}
                        </small>
                    </div>

                    <div class="form-group col-md-12 col-sm-12">
                        <label class="col-form-label font-weight-bold" for="organizationalModeldescription">{{ $t('organizationalModel.gridHeaders.description') }}</label>
                        <input v-if="editing" v-model="model.description" type="text" class="form-control" id="organizationalModeldescription">
                        <input v-else type="text" readonly class="form-control-plaintext" id="organizationalModeldescription" :value="model.description">
                    </div>
                </div>

                <div class="btn-group">
                    <div v-if="editing">
                        <button class="btn btn-danger"
                                @click.stop="cancel">
                            <i class="fas fa-ban"></i>
                            {{ $t('buttons.cancel')}}
                        </button>
                        <button v-if="claims.organizationalModelsRegister.update" class="btn btn-success"
                                @click.stop="save">
                            <i class="fas fa-save"></i>
                            {{ $t('buttons.save.btnText')}}
                        </button>
                    </div>
                    <div v-else>
                        <button v-if="claims.organizationalModelsRegister.update" class="btn btn-primary"
                                @click.stop="edit">
                            <i class="fas fa-edit"></i>
                            {{ $t('buttons.edit.btnText')}}
                        </button>
                        <button v-if="claims.organizationalModelsRegister.delete && model.deactivated" class="btn btn-success"
                                @click.stop="activate">
                            <i class="fas fa-check"></i>
                            {{ $t('buttons.activate.btnText')}}
                        </button>
                        <button v-if="claims.organizationalModelsRegister.delete && !model.deactivated" class="btn btn-danger"
                                @click.stop="deactivate">
                            <i class="fas fa-ban"></i>
                            {{ $t('buttons.deactivate.btnText')}}
                        </button>
                    </div>


                </div>

            </div>
        </div>
    </div>



</template>

<script>
    import { Culture, NomenclatureParentBySort } from '../../models/enums';
    import { OrganizationalModel } from '../../models/models';
    import PageTitle from '../../components/common/PageTitle';
    import MultiSelect from '../../components/dropdown/MultiSelect';
    import orgModelService from '../../services/orgModel.service';
    import DynamicMultiSelect from '../../components/dropdown/DynamicMultiSelect';
    import { mapGetters } from 'vuex';

    export default {
        inject: ['$validator'],
        props: {
            organizationalModel: {
                type: OrganizationalModel,
                required: true,
            },
            details: {
                type: Boolean,
                default: false
            }
        },
        components: {
            PageTitle,
            MultiSelect,
            DynamicMultiSelect
        },
        data() {
            return {
                model: this.organizationalModel,
                editing: false,
                expanded: true,
                origValue: {
                    type: OrganizationalModel,
                    default: null
                },
                eventFormSort: NomenclatureParentBySort.EventForm,
                eventActivitySort: NomenclatureParentBySort.EventDirection
            }
        },
        methods: {
            edit() {
                this.updateOrgiValue(this.model);
                this.editing = true;
            },
            cancel() {
                if (!this.model) {
                    this.model = new OrganizationalModel(this.origValue);
                } else {
                    this.updateModel(this.origValue);
                }

                this.editing = false;
            },
            updateModel(m) {
                this.model.name = m.name;
                this.model.nameEn = m.nameEn;
                this.model.description = m.description;
                this.model.deactivated = m.deactivated;
                this.model.createdBy = m.createdBy;
                this.model.createdAt = m.createdAt;
                this.model.eventFormIds = m.eventFormIds;
                this.model.eventActivityIds = m.eventActivityIds;
                this.model.loaded = m.loaded;
                this.model.checked = m.checked;
            },
            updateOrgiValue(m) {
                if (!this.origValue) {
                    this.origValue = new OrganizationalModel();
                }

                this.origValue.id = m.id
                this.origValue.name = m.name;
                this.origValue.nameEn = m.nameEn;
                this.origValue.description = m.description;
                this.origValue.deactivated = m.deactivated;
                this.origValue.createdBy = m.createdBy;
                this.origValue.createdAt = m.createdAt;
                this.origValue.eventFormIds = m.eventFormIds;
                this.origValue.eventActivityIds = m.eventActivityIds;
                this.origValue.loaded = m.loaded;
                this.origValue.checked = m.checked;
            },
            save() {
                this.update();
            },
            update() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        orgModelService
                            .update(this.model)
                            .then(response => {
                                this.$vs.notify({
                                    title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                                    text: this.$helpers.responseMessage(response),
                                    color: 'success',
                                    time: this.$store.getters.notificationDuration
                                });

                                if (response.data.model) {
                                    this.updateModel(new OrganizationalModel(response.data.model));
                                }

                                this.editing = false;
                                this.$emit("saved", this.model);
                            })
                            .catch(error => {
                                this.$vs.notify({
                                    title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                    text: this.$helpers.errorText(error),
                                    color: 'danger',
                                    time: this.$store.getters.notificationDuration
                                });

                                this.cancel();
                            });
                    }
                });
            },
            deactivate() {
                kendo.confirm(`${this.$t('organizationalModel.deactivateConfirm')} '${this.model.name}'?`)
                    .then(function () {
                        this.doDeactivate();
                    }.bind(this));
            },
            activate() {
                kendo.confirm(`${this.$t('organizationalModel.activateConfirm')} '${this.model.name}'?`)
                    .then(function () {
                        this.doActivate();
                    }.bind(this));
            },
            doDeactivate() {
                orgModelService
                    .deactivat(this.model.id)
                    .then(response => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.editing = false;
                        this.model.deactivated = true;
                        this.$emit("orgModelDeactivated", this.model);
                    })
                    .catch(error => {
                        this.editing = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            doActivate() {
                orgModelService
                    .activate(this.model.id)
                    .then(response => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                            text: this.$helpers.responseMessage(response),
                            color: 'success',
                            time: this.$store.getters.notificationDuration
                        });

                        this.editing = false;
                        this.model.deactivated = false;
                        this.$emit("orgModelActivated", this.model);
                    })
                    .catch(error => {
                        this.editing = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            }

        },
        computed: {
            ...mapGetters(['claims']),
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
            validNameValue() {
                if (!this.model.name) {
                    return false;
                }

                return true;
            }
        }
    }
</script>
